import React from 'react'
import PropTypes from 'prop-types'
import styles from '../TabStyles'
import buildTextEditor from '../../buildTextEditor'
import PostApptReviewMessage from './index'

const PostApptReviewTextEditor = buildTextEditor(PostApptReviewMessage)
const TextEditors = ({ editors }) => (
  <div style={styles.editorColumn}>
    {editors.map(({
      maxChars,
      pmsType,
      pmsVersion,
      setting,
      title,
      updateSetting,
    }) => (
      <PostApptReviewTextEditor
        hasPlum={false}
        hasReviews
        key={setting.id}
        maxChars={maxChars}
        pmsType={pmsType}
        pmsVersion={pmsVersion}
        setting={setting}
        title={title}
        updateSetting={updateSetting}
      />
    ))}
  </div>
)

TextEditors.propTypes = {
  editors: PropTypes.arrayOf(
    PropTypes.shape({
      maxChars: PropTypes.number,
      pmsType: PropTypes.string,
      setting: PropTypes.shape({
        id: PropTypes.number,
      }),
      title: PropTypes.string,
      updateSetting: PropTypes.func.isRequired,
    }),
  ),
}

export default TextEditors



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/PostApptReviewSettingsEditors/TextEditors.js